import {useContext} from 'react';
import {AxiosError} from 'axios';
import {ToastType} from 'patient-ping-remedy/packages/toast';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {DeAgencyEvent} from '@/api/dto/encounter';
import {useAlertStore} from '@/store/alert_store';
import Helpers from '@/helpers/helpers';
import {GENERICERROR} from '@manual_encounters/constants/BannerMessages';

export interface DeAgencySync {
  rosterId: number;
  patientId: string;
  encounterId: string;
  event: DeAgencyEvent;
  agency?: string | null;
  storedAgency?: string | null;
}

export function useDeAgencySync() {
  const { encounterApi } = useContext(CarecoApiContext);
  const { addAlert } = useAlertStore();

  // Runs after Pings has accepted the save, so it never rejects: a failure here must not undo
  // or repeat that save. It reports the failure without logging it, because the request
  // carries the agency. An unchanged agency sends nothing, so an edit that keeps it can't
  // end in an error.
  return async ({ rosterId, patientId, encounterId, event, agency, storedAgency }: DeAgencySync) => {
    try {
      if (agency && agency !== storedAgency) {
        await encounterApi!.updateDeAgency(patientId, rosterId, encounterId, event, agency);
      } else if (!agency && storedAgency) {
        await encounterApi!.deleteDeAgency(patientId, rosterId, encounterId, event);
      }
    } catch (error) {
      addAlert({ content: `${GENERICERROR} ${Helpers.traceId(error as AxiosError)}`, type: ToastType.ERROR });
    }
  };
}
